import { isShopMode } from './params';

const locales: { [index: string]: string } = {
  dk: 'da',
  en: 'en-gb',
  us: 'en-us',
  es: 'es',
  de: 'de',
  fi: 'fi',
  fr: 'fr',
  fr_CA: 'fr-ca',
  it: 'it',
  nl: 'nl',
  no: 'no',
  pl: 'pl',
  se: 'sv',
};

const articles: { [index: string]: { [index: string]: string } } = {
  DEFAULT: {
    printTypes: '115004036234',
    printingCost: '207153579',
    pricePerPrintArea: '207153579',
    pixelGraphics: '207945305',
    vectorGraphics: '206775719',
    designLegalAgreement: '206779109',
    shipping: '207165489',
    graphicsRequirements: '360011212033',
    discountDisclaimer: '207863285',
    screenPrinting: '4402857317266',
  },
  SPREADSHOP: {
    printingCost: '115003237993',
    pixelGraphics: '360012941280',
    vectorGraphics: '360012941260',
    designLegalAgreement: '360012941320',
    shipping: '115000993925',
    graphicsRequirements: '360012941280',
  },
};

let locale: string;
export const initFaqLocale = (newLocale: string) => {
  locale = locales[newLocale] || locales[newLocale.split('_').shift() as string] || 'en-gb';
};

export const getFaqUrl = (what: string) => {
  const article = isShopMode()
    ? articles.SPREADSHOP[what] || articles.DEFAULT[what]
    : articles.DEFAULT[what];
  const helpCenterUrl =
    isShopMode() && articles.SPREADSHOP[what]
      ? 'https://service.spreadshirt.com/hc/'
      : 'https://help.spreadshirt.com/hc/';

  return article ? `${helpCenterUrl}${locale}/articles/${article}` : '';
};
